import { ICardPaymentOptions, IUserProfileService, PaymentCard } from '../@posturinn/client-react';
import { AccountUsesNewFlow } from '../@posturinn/client-react/data/account-uses-new-flow.do';
import {
	ACTIVATE_3DSECURE,
	CREATE_PAYMENT_CARD,
	CREATE_PAYMENT_CARD_ERROR,
	CREATE_PAYMENT_CARD_PENDING,
	DELETE_PAYMENT_CARD_ERROR,
	DELETE_PAYMENT_CARD_FULFILLED,
	DELETE_PAYMENT_CARD_PENDING,
	GET_USES_NEW_FLOW,
	GET_USES_NEW_FLOW_ERROR,
	GET_USES_NEW_FLOW_PENDING,
	INITIALIZE_PAYMENT_CARD,
	INITIALIZE_PAYMENT_CARD_ERROR,
	INITIALIZE_PAYMENT_CARD_PENDING,
	PAYMENT_ERROR,
	PAYMENT_FULFILLED,
	PAYMENT_PENDING,
} from '../constants/actions/paymentActions';
import { closeAllModals } from './modalActions';

export const getPaymentCard = () => {
	return async function (dispatch, getState) {
		const { injector } = getState().mobizReducer;
		const userProfileService: IUserProfileService = injector.get(IUserProfileService);
		dispatch(getPaymentCardPending());
		userProfileService.getPaymentCards().subscribe({
			next: (paymentCards: PaymentCard[]) => {
				dispatch(getPaymentCardFulfilled(paymentCards));
			},
			error: error => {
				console.log(error);
				dispatch(getPaymentCardError());
			},
		});
	};
};

export const createPaymentCard = (cardholderName, cardNumber, securityCode, expiryMonth, expiryYear) => {
	return async function (dispatch, getState) {
		const { injector } = getState().mobizReducer;
		const userProfileService: IUserProfileService = injector.get(IUserProfileService);
		dispatch(createPaymentCardPending());

		const paymentCard = new PaymentCard();
		paymentCard.cardholderName = cardholderName;
		paymentCard.cardNumber = cardNumber;
		paymentCard.securityCode = securityCode;
		paymentCard.expiryMonth = expiryMonth;
		paymentCard.expiryYear = expiryYear;

		userProfileService.addPaymentCard(paymentCard).subscribe({
			next: (response: PaymentCard) => {
				if (response.cardVerificationRawResponse) {
					dispatch(activate3DSecure(response.cardVerificationRawResponse));
				} else {
					dispatch(createPaymentCardFulfilled(response));
				}
				dispatch(closeAllModals());
				document.body.style.overflow = 'unset';
			},
			error: error => {
				let err = '';
				if (error.info.details) err = error.info.details;
				dispatch(createPaymentCardError(err));
			},
		});
	};
};

export const updatePaymentCard = () => {
	// TODO
};

export const deletePaymentCard = paymentCardId => {
	return async function (dispatch, getState) {
		const { injector } = getState().mobizReducer;
		const userProfileService: IUserProfileService = injector.get(IUserProfileService);
		dispatch(deletePaymentCardPending());

		userProfileService.deletePaymentCard(paymentCardId).subscribe({
			next: () => {
				dispatch(deletePaymentCardFulfilled());
				dispatch(closeAllModals());
			},
			error: error => {
				console.log(error);
				dispatch(deletePaymentCardError());
			},
		});
	};
};

// salesOffice is '998' for authorized users.
// TODO Different for unauthorized use.
export const payWithCard = (paymentCard, items, product, salesOffice, save: boolean, page, index) => {
	return async function (dispatch, getState) {
		const { injector } = getState().mobizReducer;
		const userProfileService: IUserProfileService = injector.get(IUserProfileService);
		dispatch({ type: PAYMENT_PENDING, payload: null });

		const paymentOptions: ICardPaymentOptions = {
			items: items,
			card: paymentCard,
			product: product,
			salesOffice: salesOffice,
		};

		if (paymentCard.cardNumber.includes('*'))
			userProfileService.payWithSavedCard(paymentOptions, save).subscribe({
				next: () => {
					dispatch(paymentFulfilled(page, index));
					dispatch(closeAllModals());
					document.body.style.overflow = 'unset';
				},
				error: error => {
					dispatch({ type: PAYMENT_ERROR, payload: error.info.details });
				},
			});
		else
			userProfileService.payWithCard(paymentOptions, save).subscribe({
				next: response => {
					if (response.cardVerificationRawResponse) {
						window.sessionStorage.setItem('returnUrl', window.location.toString());
						dispatch(activate3DSecure(response.cardVerificationRawResponse));
					} else {
						dispatch(paymentFulfilled(page, index));
						dispatch(closeAllModals());
						document.body.style.overflow = 'unset';
					}
				},
				error: error => {
					dispatch({ type: PAYMENT_ERROR, payload: error.info.details });
				},
			});
	};
};

export const startNewFlow = (paymentCard, items, product, salesOffice, save: boolean, page, index) => {
	return async function (dispatch, getState) {
		const { injector } = getState().mobizReducer;
		const userProfileService: IUserProfileService = injector.get(IUserProfileService);
		dispatch({ type: PAYMENT_PENDING, payload: null });

		const paymentOptions: ICardPaymentOptions = {
			items: items,
			card: paymentCard,
			product: product,
			salesOffice: salesOffice,
		};

		if (paymentCard.cardNumber.includes('*'))
			userProfileService.payWithSavedCard(paymentOptions, save).subscribe({
				next: () => {
					dispatch(paymentFulfilled(page, index));
					dispatch(closeAllModals());
					document.body.style.overflow = 'unset';
				},
				error: error => {
					dispatch({ type: PAYMENT_ERROR, payload: error.info.details });
				},
			});
		else
			userProfileService.payWithCardChallengeDecidedByIssuer(paymentOptions, save).subscribe({
				next: response => {
					if (response.threeDSChallengeHtmlFormResponse?.cardVerificationRawResponse) {
						window.sessionStorage.setItem('returnUrl', window.location.toString());
						dispatch(activate3DSecure(response.threeDSChallengeHtmlFormResponse.cardVerificationRawResponse));
					} else {
						dispatch(paymentFulfilled(page, index));
						dispatch(closeAllModals());
						document.body.style.overflow = 'unset';
					}
				},
				error: error => {
					dispatch({ type: PAYMENT_ERROR, payload: error.info.details });
				},
			});
	};
};

export const getAccountUsesNewFlow = () => {
	return async function (dispatch, getState) {
		const { injector } = getState().mobizReducer;
		const userProfileService: IUserProfileService = injector.get(IUserProfileService);

		dispatch(getUsesNewFlowPending());

		userProfileService.getAccountUsesNewFlow().subscribe({
			next: (dto: AccountUsesNewFlow) => {
				dispatch(getUsesNewFlowFulfilled(dto));
			},
			error: error => {
				console.log(error);
				dispatch(getUsesNewFlowError());
			},
		});
	};
};

export const getPaymentCardFulfilled = data => ({
	type: INITIALIZE_PAYMENT_CARD,
	payload: {
		paymentCard: data,
	},
});

export const getPaymentCardPending = () => ({
	type: INITIALIZE_PAYMENT_CARD_PENDING,
	payload: null,
});

export const getPaymentCardError = () => ({
	type: INITIALIZE_PAYMENT_CARD_ERROR,
	payload: null,
});

export const activate3DSecure = data => ({
	type: ACTIVATE_3DSECURE,
	payload: {
		html: data,
	},
});

export const createPaymentCardFulfilled = data => ({
	type: CREATE_PAYMENT_CARD,
	payload: {
		paymentCard: data,
	},
});

export const createPaymentCardPending = () => ({
	type: CREATE_PAYMENT_CARD_PENDING,
	payload: null,
});

export const createPaymentCardError = error => ({
	type: CREATE_PAYMENT_CARD_ERROR,
	payload: error,
});

export const deletePaymentCardFulfilled = () => ({
	type: DELETE_PAYMENT_CARD_FULFILLED,
	payload: null,
});

export const deletePaymentCardPending = () => ({
	type: DELETE_PAYMENT_CARD_PENDING,
	payload: null,
});

export const deletePaymentCardError = () => ({
	type: DELETE_PAYMENT_CARD_ERROR,
	payload: null,
});

export const paymentFulfilled = (page, index) => ({
	type: PAYMENT_FULFILLED,
	payload: {
		currentPage: page,
		shipmentIndex: index,
	},
});

export const getUsesNewFlowFulfilled = (data: AccountUsesNewFlow) => ({
	type: GET_USES_NEW_FLOW,
	payload: {
		accountUsesNewFlow: data, // keep a named field like other actions (e.g., paymentCard)
	},
});

export const getUsesNewFlowPending = () => ({
	type: GET_USES_NEW_FLOW_PENDING,
	payload: null,
});

export const getUsesNewFlowError = () => ({
	type: GET_USES_NEW_FLOW_ERROR,
	payload: null,
});
